module.exports = "/_next/static/images/cy-ce826661e7ca1778b9bb3a768ff69d13.svg";